import React from 'react'
import Sketch from 'react-p5'

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

let strings = new LocalizedStrings({
    en:{
        title:"walk",
        description:""
    },
    de: {
        title:"gehen",
        description:""
    }
});

const extensions = require("./extensions")

function playChar(c, pan, pitch) {

}

class PropertyChars {
    constructor(values) {
        this.value = extensions.randomChoice(values)
        this.pos = 0
        this.isProperty = true
    }

    next() {
        this.pos = (this.pos + 1) % this.value.length
        return this.value.substring(this.pos, this.pos+1)
    }

    getRandom() {
        let p = Math.random(1, this.value.length)
        return this.value.substring(p, p+1)
    }

    reset() {
        this.pos = 0
    }

}

class Property {
    constructor(startValue, growthFact, inc, mutationFact) {
        this.startValue = startValue
        this.value = startValue
        this.growthFact = growthFact
        this.inc = inc
        this.isProperty = true
    }

    get() {
        return this.value
    }

    reset() {
        this.value = this.startValue
    }

    advance() {
        this.value *= this.growthFact
        this.value += this.inc
    }
}

class ParameterSet {
    constructor(p5) {
        let fontSizeStart = p5.width/30
        let maxFontSize = p5.width/4
        this.stepSizeDiv = 4
        let fontSizeInc = (maxFontSize-fontSizeStart)/1000
        this.angleDevInc = 0.002*Math.PI/180

        this.angleDev = 10*Math.PI/180

        this.chars = new PropertyChars(["abcdefghijklmnopqrstuvwxyz", "?!", "-.,_:;#+=/", "äöoauoäöüöäüöauo", "ijlt", "qpg", "@", "<>{}()[]"])
        this.fontSize = new Property(fontSizeStart, 1, fontSizeInc, 0.2)
    }

    step(p5) {
		p5.fill(255, 255, 255, 255*0.9)
        p5.stroke(0,0,0, 255)

        var c = this.chars.next()
        p5.textSize(this.fontSize.get())

		this.angle += p5.random(-this.angleDev, this.angleDev)

        var context = p5.drawingContext; // or p5.drawingContext
        context.shadowOffsetX = 0
        context.shadowOffsetY = 0
        context.shadowBlur = 30;
        context.shadowColor = '#000';

		p5.push()
		p5.translate(this.xp, this.yp)
        p5.rotate(this.angle)
        p5.textAlign(p5.CENTER, p5.CENTER)
        p5.text(c, 0,0)
		p5.pop()

        let pan = (this.xp - p5.width/2) / p5.width * 2
        let pitch = 1 + ((this.yp / p5.height) - 0.5) / 2
        playChar(c, pan, pitch)

		this.xp += Math.cos(this.angle)*this.fontSize.get()/this.stepSizeDiv
		this.yp += Math.sin(this.angle)*this.fontSize.get()/this.stepSizeDiv
		if (this.xp > p5.width) {
			this.xp -= p5.width
		}
		if (this.xp < 0) {
			this.xp += p5.width
		}
		if (this.yp > p5.height) {
			this.yp -= p5.height
		}
		if (this.yp < 0) {
			this.yp += p5.height
		}

        this.fontSize.advance()
		this.angleDev += this.angleDevInc

        return false
    }

    startAnimation(p5) {
        this.running = true

        this.stepNr = 1
        this.xp = 0
        this.yp = p5.height/2
        this.angle = 0

        this.chars.reset()
        this.fontSize.reset()
    }
}

class Walk extends React.Component {
    constructor(props) {
        super(props)

        this.fontSize = 10

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    reset(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)
        p5.background(0)

        this.parameterSet = new ParameterSet(p5)
        this.parameterSet.startAnimation(p5)
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        console.log("setup!")

        this.fontSize = window.innerWidth / 60

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)

        this.reset(p5)
    }

    draw(p5) {
        if (this.parameterSet !== undefined) {
            console.log(".")
            this.parameterSet.step(p5)
        }
    }

    windowResized(p5) {
        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
Walk.contextType = LanguageContext

export default Walk
